import React from 'react';
import CategoryNavigation from './CategoryNavigation.js';
import ProductGrid from '../products/ProductGrid.js';

const NavigationSection = ({
  loading,
  error,
  viewState,
  selectedMainCategory,
  selectedSubCategory,
  onBack,
  categoryScrollRef,
  categoryScrollState,
  shouldShowArrows,
  scrollCategoriesLeft,
  scrollCategoriesRight,
  categories,
  selectedCategory,
  onCategoryClick,
  products,
  selectedProduct,
  productScrollRef,
  productScrollState,
  scrollProducts,
  isProductInBuild,
  onProductSelect,
  onProductToggle,
  onProductInfo,
  productInBuild,
  categoryConfig,
  hasRealSubCategories,
  compulsoryData
}) => {
  return (
    <div className="w-full">
      <div className="nav-glass-premium px-1 pb-1 lg:px-2.5 lg:pb-2.5">
        
        {/* Category Navigation */}
        <CategoryNavigation
          loading={loading}
          error={error}
          viewState={viewState}
          onBack={onBack}
          categoryScrollRef={categoryScrollRef}
          categoryScrollState={categoryScrollState}
          shouldShowArrows={shouldShowArrows}
          scrollCategoriesLeft={scrollCategoriesLeft}
          scrollCategoriesRight={scrollCategoriesRight}
          categories={categories}
          selectedCategory={selectedCategory}
          onCategoryClick={onCategoryClick}
          categoryConfig={categoryConfig}
          selectedMainCategory={selectedMainCategory}
          compulsoryData={compulsoryData}
        />

        {/* Product Grid */}
        <div className="relative z-20 bg-[#d0d0d0] -mx-1 lg:-mx-2.5 -mb-1 lg:-mb-2.5 px-1 lg:px-2.5 pb-1 lg:pb-2.5">
        <ProductGrid
          loading={loading}
          error={error}
          products={products}
          selectedProduct={selectedProduct}
          selectedMainCategory={selectedMainCategory}
          selectedSubCategory={selectedSubCategory}
          isProductInBuild={isProductInBuild}
          onProductSelect={onProductSelect}
          onProductToggle={onProductToggle}
          onProductInfo={onProductInfo}
          productInBuild={productInBuild}
          categoryConfig={categoryConfig}
          hasRealSubCategories={hasRealSubCategories}
        />
        </div>
      </div>
    </div>
  );
};

export default NavigationSection;
